// Cookie utilities kept minimal and framework-agnostic

export function deleteCookie(name: string): void {
  try {
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const path = 'path=/';
    // Basic delete
    document.cookie = `${name}=; expires=${expires}; ${path}`;

    // Attempt domain-scoped deletions for subdomains
    const hostname = window.location.hostname;
    const domainsToTry = new Set<string>();
    domainsToTry.add(hostname);
    if (!hostname.startsWith('.')) domainsToTry.add(`.${hostname}`);
    const parts = hostname.split('.');
    if (parts.length > 2) {
      const apex = parts.slice(-2).join('.');
      domainsToTry.add(apex);
      domainsToTry.add(`.${apex}`);
    }

    domainsToTry.forEach((domain) => {
      document.cookie = `${name}=; expires=${expires}; domain=${domain}; ${path}`;
    });
  } catch {
    // ignore cookie errors
  }
}

export function clearAllAppCookies(): void {
  try {
    // Clear by enumeration
    const cookies = document.cookie ? document.cookie.split(';') : [];
    cookies.forEach((c) => {
      const eqIdx = c.indexOf('=');
      const cookieName = (eqIdx > -1 ? c.substring(0, eqIdx) : c).trim();
      if (cookieName) deleteCookie(cookieName);
    });
  } catch {
    // ignore cookie errors
  }
}


